import React from 'react';
import Heading from '@tds/core-heading';
import PropTypes from 'prop-types';

import { formatPrice } from '../../../utils/utils';
import { getLocalizedStrings, getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import {
  staticIp5LabelPromotion,
  staticIpSubnet1Label,
  staticIpSubnet5Label
} from '../../../utils/constant';

const OfficeInternetFiber = ({ officeInternetFiber }) => {
  const locale = getLocale();

  const {
    WLS: {
      _switchCreditPromo,
      _5yearPromos,
      _staticIpSubnet1Label,
      _staticIpSubnet5Label,
      _staticIpDynamic5Label,
      _staticIpSubnet0Label
    }
  } = locale === 'en-US' ? EN : FR;

  const {
    quoteSummary: {
      products: { officeInternetFiber: labelOfficeInternetFiber },
      fiberInternet,
      regularOffer,
      limitedTimeOffer,
      table: { qty, oneTimeCharges, monthlyCharges, total }
    },
    contentfulValues: { bundledOffer }
  } = getLocalizedStrings();
  const {
    speed: {
      value: speedValue,
      qty: speedQty,
      prices: { oneTime: speedOneTime, monthly: speedMonthly } = {}
    } = {},
    staticIp: {
      value: staticIpValue,
      qty: staticIpQty,
      prices: { monthly: staticIpMonthly, oneTime: staticIpOneTime } = {}
    } = {},
    staticIpPromotion: {
      value: staticIpValuePromotion,
      qty: staticIpQtyPromotion,
      prices: {
        monthly: staticIpMonthlyPromotion,
        oneTime: staticIpOneTimePromotion
      } = {}
    } = {},
    limitedTimeOffers,
    regularOffers,
    totalMonthly,
    wifiAccess,
    bundledOffers,
    fiveYearlyPromo,
    blackFridayPromo,
    switchCreditPromo,
    totalOneTime
  } = officeInternetFiber || {};

  // static ip label is returned based on user selection
  const staticIpLabelFunc = () => {
    if (staticIpValue === _staticIpSubnet5Label) {
      return _staticIpSubnet5Label;
    } else if (staticIpValue === _staticIpSubnet1Label) {
      return _staticIpSubnet1Label;
    } else if (staticIpValue === _staticIpSubnet0Label) {
      return _staticIpSubnet0Label;
    } else if (staticIpValue === _staticIpDynamic5Label) {
      return _staticIpDynamic5Label;
    }
    return 'Static Ips';
  };

  return (
    <>
      {officeInternetFiber && (
        <div style={{ overflowX: 'auto' }}>
          <Heading level="h3">{labelOfficeInternetFiber}</Heading>
          <br />
          <table>
            <thead>
              <tr>
                <th width="60%"></th>
                <th>{qty}</th>
                <th>{oneTimeCharges}</th>
                <th>{monthlyCharges}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {fiberInternet} {speedValue}
                </td>
                <td>{speedQty}</td>
                <td>{formatPrice(speedOneTime)}</td>
                <td>{formatPrice(speedMonthly)}</td>
              </tr>
              {officeInternetFiber.staticIp && (
                <tr>
                  <td>{staticIpLabelFunc()}</td>
                  <td>{staticIpQty}</td>
                  <td>{formatPrice(staticIpOneTime)}</td>
                  <td>{formatPrice(staticIpMonthly)}</td>
                </tr>
              )}
              {officeInternetFiber.staticIpPromotion && (
                <tr>
                  <td>{staticIpValuePromotion}</td>
                  <td>{staticIpQtyPromotion}</td>
                  <td>{formatPrice(staticIpOneTimePromotion)}</td>
                  <td>{formatPrice(staticIpMonthlyPromotion)}</td>
                </tr>
              )}
              {regularOffers &&
                regularOffers.length > 0 &&
                regularOffers.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`InternetFiberRegularOffer${roValue}`}>
                      <td>
                        {regularOffer}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
              {wifiAccess &&
                wifiAccess.length > 0 &&
                wifiAccess.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`WifiAccess${roValue}`}>
                      <td>Wifi Access: {roValue}</td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
              {limitedTimeOffers &&
                limitedTimeOffers.length > 0 &&
                limitedTimeOffers.map(
                  ({
                    value: ltoValue,
                    qty: ltoQty,
                    prices: { oneTime: ltoOneTime, monthly: ltoMonthly } = {}
                  }) => (
                    <tr key={`InternetFiberLimitedTimeOffer${ltoValue}`}>
                      <td>
                        {limitedTimeOffer}: {ltoValue}
                      </td>
                      <td>{ltoQty}</td>
                      <td>{formatPrice(ltoOneTime)}</td>
                      <td>{formatPrice(ltoMonthly)}</td>
                    </tr>
                  )
                )}
              {bundledOffers &&
                bundledOffers.length > 0 &&
                bundledOffers.map(
                  ({
                    value: ltoValue,
                    qty: ltoQty,
                    prices: { oneTime: ltoOneTime, monthly: ltoMonthly } = {}
                  }) => (
                    <tr key={`InternetFiberBundledOffer${ltoValue}`}>
                      <td>
                        {bundledOffer}: {ltoValue}
                      </td>
                      <td>{ltoQty}</td>
                      <td>{formatPrice(ltoOneTime)}</td>
                      <td>{formatPrice(ltoMonthly)}</td>
                    </tr>
                  )
                )}
              {fiveYearlyPromo &&
                fiveYearlyPromo.length > 0 &&
                fiveYearlyPromo.map(
                  ({
                    value: ltoValue,
                    qty: ltoQty,
                    prices: { oneTime: ltoOneTime, monthly: ltoMonthly } = {}
                  }) => (
                    <tr key={`fiveYearlyPromo${ltoValue}`}>
                      <td>
                        {_5yearPromos}: {ltoValue}
                      </td>
                      <td>{ltoQty}</td>
                      <td>{formatPrice(ltoOneTime)}</td>
                      <td>{formatPrice(ltoMonthly)}</td>
                    </tr>
                  )
                )}
              {/* {blackFridayPromo &&
                blackFridayPromo.length > 0 &&
                blackFridayPromo.map(
                  ({
                    value: ltoValue,
                  }) => (
                    <tr key={`blackFridayPromo${ltoValue}`}>
                      <td>
                        {'Black Friday Promos'}:{ltoValue}
                      </td>
                    </tr>
                  )
                )} */}
              {switchCreditPromo &&
                switchCreditPromo.length > 0 &&
                switchCreditPromo.map(
                  ({
                    value: ltoValue,
                    prices: { oneTime: ltoOneTime, monthly: ltoMonthly } = {}
                  }) => (
                    <tr key={`switchCreditPromo${ltoValue}`}>
                      <td>
                        {_switchCreditPromo}:{` `}
                        {ltoValue}
                      </td>
                      <td>{}</td>
                      <td>{formatPrice(ltoOneTime)}</td>
                      <td>{formatPrice(ltoMonthly)}</td>
                    </tr>
                  )
                )}
              <tr>
                <td>{total}</td>
                <td></td>
                <td>{formatPrice(totalOneTime)}</td>
                <td>{formatPrice(totalMonthly)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

OfficeInternetFiber.defaultProps = {
  officeInternetFiber: {}
};

OfficeInternetFiber.propTypes = {
  officeInternetFiber: PropTypes.objectOf(PropTypes.any)
};

export default OfficeInternetFiber;
